<!--
    O card do médico fica dentro do corpo do card "Parâmetros", que tem 1.125rem de padding. Esse
    recuo é mantido de propósito: o card do médico tem borda própria e, colado nas bordas do card de
    parâmetros, as duas linhas se sobrepõem e viram uma costura só.
-->
<app-pessoa-detalhe-mobile
    class="block"
    [pessoa]="pessoa()"
    [pessoaResponse]="pessoaResponse()"
    [exibirMaisInfoRelatorio]="true"
    [trataAvatarRelatorio]="true"
    [removerSombraCard]="true"
    [exibirBordaCard]="true"
    [exibirBotaoPesquisaAvancada]="true"
    (onPesquisaAvancada)="alterar.emit()"
></app-pessoa-detalhe-mobile>
